'use strict';

( function ( $ ) {
	$( document ).on( 'click', '.modal-popup__close', function () {
		const $modalOverlay = $( this ).closest( '.modal-popup__overlay' );
		$modalOverlay.fadeOut( '100' );
		$( 'body' ).css( 'overflow', 'auto' );
	} );

	const $modal = $( '.modal-popup__overlay' );
	const modalId = $modal.attr( 'id' );
	const cookieTime = parseInt( $modal.data( 'cookie-time' ), 10 );

	if ( $modal.length && ! getCookie( modalId + '_shown' ) ) {
		$modal.fadeIn( '100' );
		$( 'body' ).css( 'overflow', 'hidden' );

		$modal.on( 'click', function ( e ) {
			if ( $( e.target ).hasClass( 'modal-popup__overlay' ) ) {
				$modal.fadeOut( '100' );
				$( 'body' ).css( 'overflow', 'auto' );
				setCookie( modalId + '_shown', 'true', cookieTime );
			}
		} );

		$modal.on( 'click', '.close-modal', function () {
			$modal.fadeOut( '100' );
			setCookie( modalId + '_shown', 'true', cookieTime );
		} );

		$modal.on( 'submit', 'form', function () {
			setCookie( modalId + '_shown', 'true', cookieTime );
		} );
	}

	function setCookie( name, value, days ) {
		let expires = '';
		if ( days ) {
			const date = new Date();
			date.setTime( date.getTime() + days * 24 * 60 * 60 * 1000 );
			expires = '; expires=' + date.toUTCString();
		}
		document.cookie = name + '=' + ( value || '' ) + expires + '; path=/';
	}

	function getCookie( name ) {
		const nameEQ = name + '=';
		const ca = document.cookie.split( ';' );
		for ( let i = 0; i < ca.length; i++ ) {
			let c = ca[ i ];
			while ( c.charAt( 0 ) === ' ' ) c = c.substring( 1, c.length );
			if ( c.indexOf( nameEQ ) === 0 )
				return c.substring( nameEQ.length, c.length );
		}
		return null;
	}

	function modalPopupCountdownTimer() {
		const timeLeft =
			Math.max(
				Date.parse(
					jQuery( '#modal_popup_countdown' ).attr( 'data-endtime' )
				) - Date.now(),
				0
			) / 1000;

		const formatTime = ( time ) =>
			String( Math.floor( time ) ).padStart( 2, '0' );
		const days = formatTime( timeLeft / 86400 );
		const hours = formatTime( ( timeLeft % 86400 ) / 3600 );
		const minutes = formatTime( ( timeLeft % 3600 ) / 60 );
		const seconds = formatTime( timeLeft % 60 );

		$( '#modal_popup_countdown' ).html( `
			<span class='modal-popup__countdown-item' id='modal_popup_countdown_days'>
				<span class='modal-popup__countdown-number'>${ days }</span><span class='modal-popup__countdown-text'>Days</span>
			</span>
			<span class='modal-popup__countdown-item' id='modal_popup_countdown_hours'>
				<span class='modal-popup__countdown-number'>${ hours }</span><span class='modal-popup__countdown-text'>Hours</span>
			</span>
			<span class='modal-popup__countdown-item' id='modal_popup_countdown_minutes'>
				<span class='modal-popup__countdown-number'>${ minutes }</span><span class='modal-popup__countdown-text'>Minutes</span>
			</span>
			<span class='modal-popup__countdown-item' id='modal_popup_countdown_seconds'>
				<span class='modal-popup__countdown-number'>${ seconds }</span><span class='modal-popup__countdown-text'>Seconds</span>
			</span>
		` );
	}

	setInterval( function () {
		modalPopupCountdownTimer();
	}, 1000 );
} )( jQuery );
